import { Card } from "@/components/ui/card";
import type { RiskMember } from "@/api/intelligence";
import { RiskBadge } from "./RiskBadge";

type Props = {
  members: RiskMember[];
};

export function TopRiskMembers({ members }: Props) {
  return (
    <Card className="p-5">
      <h2 className="mb-4 text-lg font-semibold">Top At-Risk Members</h2>

      <div className="space-y-3">
        {members.map((member) => (
          <div
            key={member.member_id}
            className="flex items-center justify-between rounded-lg border p-4"
          >
            <div>
              <p className="font-medium">{member.full_name}</p>
              <p className="text-sm text-muted-foreground">
                Risk Score {member.score}
              </p>
            </div>

            <RiskBadge level={member.level} />
          </div>
        ))}
      </div>
    </Card>
  );
}